module.exports = __webpack_public_path__ + "img/Zoom.c49c2ce0.png";